// extracted by mini-css-extract-plugin
module.exports = {"sticky":"ShoppingCart_sticky__8IUjJ","header":"ShoppingCart_header__GLw6y","buttonGroup":"ShoppingCart_buttonGroup__m4L1T","price":"ShoppingCart_price__qYoJp"};